import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemText
} from "@mui/material";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import "./style.css"; // ✅ make sure this file exists for animations
import Logo from "../../assets/logo.jpeg"
import LogoDark from "../../assets/logoDark.jpg"
import CloseIcon from '@mui/icons-material/Close';

const Header = ({ mode, toggleTheme }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [spin, setSpin] = useState(false);

  const menuItems = [
    { text: "Home", path: "/" },
    { text: "About", path: "/about" },
    { text: "Services", path: "/services" },
    { text: "Careers", path: "/careers" },
    { text: "Contact", path: "/contact" },
  ];

  const toggleDrawer = (open) => () => setDrawerOpen(open);

  // 🔄 Trigger logo spin at intervals
  useEffect(() => {
    const interval = setInterval(() => {
      setSpin(true);
      setTimeout(() => setSpin(false), 1500); // matches animation duration
    }, 10000); // every 10 seconds
    return () => clearInterval(interval);
  }, []);

  const myLogo = mode == "light" ? "black" : "white";

  return (
    <AppBar
      position="fixed"
      sx={{ background: mode === "light" ? "white" : "black", height: 70 }}
    >
      <Toolbar>
        {/* Logo + Brand */}
        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
          <img
            src={mode == "light" ? Logo : LogoDark}
            alt="Olyvia Tech Logo"
            className={spin ? "logo-spin" : ""}
            style={{ width: 60, height: 60, marginRight: "10px", borderRadius: 40 }}
          />
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: mode === "light" ? "black" : "white" }}
          >
            Olyvia Tech
          </Typography>
        </Box>

        {/* Desktop Menu */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            gap: 2,
            color: mode === "light" ? "text.secondary" : "#ccc",
          }}
        >
          {menuItems.map((item) => (
            <Button key={item.text} component={Link} to={item.path} color="inherit">
              {item.text}
            </Button>
          ))}
        </Box>

        {/* Theme Toggle */}
        <IconButton color="inherit" onClick={toggleTheme}>
          {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
        </IconButton>

        {/* Mobile Menu */}
        <Box sx={{ display: { xs: "flex", md: "none" } }}>
          <IconButton color="inherit" onClick={toggleDrawer(true)}>
            <MenuIcon />
          </IconButton>
        </Box>
      </Toolbar>

      {/* Drawer Menu */}
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 250, position: 'relative' }} onClick={toggleDrawer(false)} >
          <IconButton
            onClick={toggleDrawer(false)}
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
              color: mode === 'dark' ? '#ccc' : '#555'
            }}
          >
            <CloseIcon />
          </IconButton>
          <List>
            {menuItems.map((item) => (
              <ListItem button key={item.text} component={Link} to={item.path}>
                <ListItemText sx={{
                  "& .MuiTypography-root": {
                    color: mode === 'dark' ? '#ccc' : '#555', // Change color based on the mode
                    fontSize: '0.9rem',  // Optional: adjust font size as needed
                  },
                }} primary={item.text} />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default Header;
